import { useState } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { Link, useNavigate } from "react-router-dom";
import { message } from "antd";
import Swal from "sweetalert2";
import { LeftCircleOutlined } from "@ant-design/icons";
import { Auth } from "../../utils/Auth";
import { CountryApi } from "../../api/countryApi";

const CreateCountryView = () => {
    const navigate = useNavigate();
    const abortController = new AbortController();

    const [formData, setFormData] = useState({
        name: '',
        iso_code: '',
        phone_code: '',
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await CountryApi.storeCountry(JSON.stringify(formData), abortController.signal);

            if (!res.success) {
                setLoading(false);
                return Swal.fire({ title: "Impossible d'enregistrer", text: res.message });
            }

            message.success('Pays créé avec succès');
            navigate('/pays');
        } catch (error) {
            setLoading(false);
            message.error("Une erreur est survenue lors de la création du pays");
            const messages = await error?.messages ?? error?.message;

            if (messages instanceof Array)
                return Swal.fire({
                    title: messages.join('\n') !== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                    text: messages.join('\n') !== 'Unauthenticated' ? "Veuillez vous reconncter." : "Votre session a expirée veuillez vous reconnecter",
                    icon: "error",
                }).then(() => {
                    if (messages.join('\n') === 'Unauthenticated') {
                        Auth.removeSessionToken();
                        return navigate(`/login`);
                    }
                });
        } finally {
            setLoading(false);
        }
    };

    return <MainLayout>
        <div className="container mx-auto p-6">
            <div className="flex justify-between">
                <h1 className="text-3xl font-semibold mb-6">Ajouter un pays</h1>
                <Link to={`/pays`}><LeftCircleOutlined /> Retour  </Link>
            </div>

            <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md space-y-4">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium mb-1">Nom</label>
                        <input type="text" name="name" value={formData.name} onChange={handleChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md" required />
                    </div>
                    <div>
                        <label className="block text-sm font-medium mb-1">Code ISO (ex: CI)</label>
                        <input type="text" name="iso_code" value={formData.iso_code} onChange={handleChange}
                            maxLength={2} className="w-full px-4 py-2 border border-gray-300 rounded-md uppercase" required />
                    </div>
                    <div>
                        <label className="block text-sm font-medium mb-1">Indicatif téléphonique</label>
                        <input type="text" name="phone_code" value={formData.phone_code} onChange={handleChange}
                            placeholder="+225" className="w-full px-4 py-2 border border-gray-300 rounded-md" />
                    </div>
                </div>

                <button type="submit" disabled={loading}
                    className="mt-4 px-4 py-2 text-white bg-africasa-secondary rounded hover:bg-africasa-primary disabled:opacity-50">
                    {loading ? 'Enregistrement...' : 'Enregistrer'}
                </button>
            </form>
        </div>
    </MainLayout>
}

export default CreateCountryView
